var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecuritypriority(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2152",
    "data-name": "Group 2152",
    transform: "translate(-1417 -1710)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1417 1710)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(1427.158 1720.147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glyph-2",
    "data-name": "Glyph",
    transform: "translate(0.15 0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3421",
    "data-name": "Path 3421",
    d: "M44.489,48.022a.463.463,0,0,0-.342.555,19.1,19.1,0,0,1,.509,4.367A18.79,18.79,0,0,1,25.887,71.712a18.547,18.547,0,0,1-11.313-3.8,3.105,3.105,0,1,0-.626.685,19.462,19.462,0,0,0,11.939,4.04,19.714,19.714,0,0,0,19.159-24.27.463.463,0,0,0-.558-.345Z",
    transform: "translate(-6.195 -33.251)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M1.075,19.853a18.769,18.769,0,0,1,28.6-15.989A2.766,2.766,0,1,0,30.2,3.1,19.7,19.7,0,0,0,.477,23.437a.459.459,0,0,0,.453.379.383.383,0,0,0,.083-.009.463.463,0,0,0,.373-.537,18.78,18.78,0,0,1-.312-3.417Z",
    transform: "translate(-0.15 -0.16)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M55,47.793v.278h5.552v-.278A2.776,2.776,0,1,0,55,47.793Z",
    transform: "translate(-38.083 -31.156)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M44.759,22.046c-5.206.052-10.215-3.164-12.13-4.552a1.38,1.38,0,0,0-1.616,0c-1.915,1.388-6.936,4.592-12.13,4.552A1.4,1.4,0,0,0,17.47,23.44c0,7.122,1.428,17.309,13.725,23.533a1.379,1.379,0,0,0,1.252,0c12.3-6.224,13.722-16.411,13.725-23.533A1.4,1.4,0,0,0,44.759,22.046ZM36.91,36.129A2.313,2.313,0,0,1,34.6,38.442H29.045a2.313,2.313,0,0,1-2.313-2.313V31.194a2.313,2.313,0,0,1,1.388-2.119V28.6c.056-4.95,7.347-4.95,7.4,0v.478a2.313,2.313,0,0,1,1.388,2.119Z",
    transform: "translate(-12.128 -11.967)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M62.088,64.747a.3.3,0,0,1,.062-.236,1,1,0,1,0-1.638,0,.3.3,0,0,1,.062.233c-.072.361-.278,1.394-.422,2.111a.617.617,0,0,0,.605.736H61.9a.617.617,0,0,0,.605-.738Z",
    transform: "translate(-41.637 -43.584)",
    fill: "#fafafa"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritypriority);
export default __webpack_public_path__ + "static/media/securitypriority.bb44f0ff1c274606e18a92e2876d6a6b.svg";
export { ForwardRef as ReactComponent };